import {Video} from './video';
import {Image} from './image';
export class Person {
  id: number;
  displayName: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  officePhone: string;
  mobilePhone: string;
  bioHTML: string;
  email: Email;
  image: Image;
  video: Video;

  constructor(public data: any) {
    const json: JSON = data;

    this.id = json['id'];
    this.displayName = json['displayName'];
    this.firstName = json['firstName'];
    this.lastName = json['lastName'];
    this.jobTitle = json['jobTitle'];
    this.officePhone = json['telephoneLandline'];
    this.mobilePhone = json['telephoneCell'];
    if (json['bio'] && json['bio']['html']) {
      this.bioHTML = json['bio']['html'];
    }
    if (json['email']) {
      this.email = new Email(json['email']);
    }

    if (json['media']) {
      if (json['media']['image']) {
        this.image = new Image(json['media']['image']);
      }
      if (json['media']['video']) {
        this.video = new Video(json['media']['video']);
      }
    }
  }
}

export class Email {
  address: string;
  displayName: string;

  constructor(public data: any) {
    const json: JSON = data;

    this.address = json['address'];
    this.displayName = json['displayName'];
  }
}



// WEBPACK FOOTER //
// ./src/app/model/person.ts